/* eslint-disable indent */

var bagggagesObserverMixin = require('../modules/mixins/baggages_observer.mixin');
Odigeo.defineWidget(
    'passengers_manager',
    Odigeo.Widget.extend(
        bagggagesObserverMixin.extend({
            passengerTypes: {
                ADULT: 'adults',
                CHILD: 'children',
                INFANT: 'infants',
            },
            passengerMap: {
                name: 'name',
                travellerTitle: 'title',
                firstLastName: 'firstLastName',
                secondLastName: 'secondLastName',
                phoneNumber1: 'phoneNumber',
                phoneCode1: 'prefixPhoneNumber',
                travellerGender: 'gender',
                dateOfBirth: 'birthDate',
            },
            contactDetailsMap: {
                address: 'address',
                cityName: 'city',
                country: 'country',
                zipCode: 'postalCode',
                buyer: {
                    name: 'name',
                    firstLastName: 'firstLastName',
                    secondLastName: 'secondLastName',
                    phoneNumber: 'phoneNumber1',
                    prefixPhoneNumber: 'phoneCode1',
                },
            },
            modelClass: require('../modules/models/passengers_manager'),
            viewClass: require('../modules/views/passengers_manager').default,
            init: function() {
                this.view._refreshInputs();
                Odigeo.trigger(this.name + ':init', this.id);

                Odigeo._.each(this.view.$cachedSelectors.passengerFields, function(field) {
                    var $el = $(field);
                    var text = $el.find('input').data('error');
                    $el.find('.wrong_label').text(text);
                });
                if (this.options.hiddenLogin || this.id === 'buyer-pay') {
                    this.view.restoreFieldsLocalStorage();
                    this.view.prefillCountryWithPrefixTelephone();
                }
            },

            passengerData() {
                const data = {widgetId: this.id};
                Odigeo._.extend(data, this.view.collectPassengerData.apply(this.view, arguments));
                if (!this.view._validateAllFields()) {
                    data.errors = true;
                }
                return data;
            },

            hasErrors() {
                return Odigeo._.get(this.passengerData(), 'errors');
            },

            validate: function() {
                Odigeo.trigger(this.name + ':completed', this.passengerData());
            },

            validateBuyerWithPaxErrors: function() {
                Odigeo.trigger(this.name + ':completedWithPaxErrors', this.passengerData());
            },

            isBuyerTemplate() {
                return this.options.isBuyerTemplate;
            },

            getBuyerDTO: function() {
                let buyerDTO = {};
                this.view.$cachedSelectors.passengerFields.each(function() {
                    let $input = $(this).find('.submit_field_focusable');
                    buyerDTO[$input.data().name] = $input.val();
                });
                return buyerDTO;
            },

            _getDefault: function(obj) {
                return Odigeo._.find(obj, function(element) {
                    return element.profile && element.profile.isDefault;
                });
            },

            _fillPassengerSelector: function(travellers, $wrapper) {
                var hasMember = !Odigeo._.isEmpty(Odigeo._.where(travellers, {id: 0}));
                var $memberOption = null;
                const travellersObject = {};
                Odigeo._.each(
                    travellers,
                    Odigeo._.bind(function(passenger) {
                        var option;
                        if (passenger.typeOfTraveller === this.model.passengerType) {
                            option = $('<option></option>')
                                .attr('value', passenger.id)
                                .text(
                                    passenger.profile.name +
                                        ' ' +
                                        passenger.profile.firstLastName +
                                        ' ' +
                                        (passenger.profile.secondLastName ? passenger.profile.secondLastName : '') +
                                        (passenger.id === 0 ? this.options.membershipOptionPremium : '')
                                );
                            travellersObject[passenger.id] = {
                                name: passenger.profile.name,
                                firstLastName: passenger.profile.firstLastName,
                                secondLastName: passenger.profile.secondLastName,
                                id: passenger.id,
                                typeOfTraveller: passenger.typeOfTraveller,
                            };
                            if (this.id === 'passengers0' && passenger.id === 0 && hasMember) {
                                if (!this.view.isStepBack() || Odigeo.AB.isFixRestorePaxPage) {
                                    this.model.passengerSelectedId = 0;
                                    $memberOption = option;
                                }
                            } else if (
                                passenger.profile.isDefault &&
                                (this.id === 'passengers0' || this.options.isBuyer) &&
                                Odigeo._.contains([0, -1], this.model.passengerSelectedId) &&
                                !hasMember
                            ) {
                                if (!this.view.isStepBack() || Odigeo.AB.isFixRestorePaxPage) {
                                    this.model.passengerSelectedId = passenger.id;
                                }
                            } else if (!this.options.isBuyer && passenger.profile.isDefault && this.id !== 'passengers0') {
                                Odigeo.trigger(this.view.widget.name + ':travellerSelected', {id: passenger.profile.id});
                            }
                            if (this.id === 'passengers0' || this.options.isBuyer || !Odigeo._.isUndefined(passenger.id)) {
                                $wrapper.append(option);
                            }
                        }
                    }, this)
                );
                Odigeo.trigger(`${this.name}:fillPassengers`, travellersObject);
                if (hasMember) {
                    $wrapper.append($wrapper.children(':first-child'));
                    $wrapper.prepend($memberOption);
                }
            },
            trackingLoggedUser: function(isBuyer) {
                this.view.trackingUtils.trackEvent('sso_pax_page', isBuyer ? 'prefilled_none_buyer' : 'prefilled_pax_none');
            },
            trackingLoggedBuyer: Odigeo._.throttle(function() {
                this.trackingLoggedUser(true);
            }, 2000),
            showPassengerList: function(data) {
                var $wrapper;
                this.model.user = data.userDTO;
                if (data && data.userDTO && data.userDTO.traveller && data.userDTO.traveller.length > 0) {
                    this.view.$cachedSelectors.customersPaxManager.removeClass('hidden');
                    $wrapper = this.options.isBuyer ? this.view.$cachedSelectors.contactDetailsSelector : this.view.$cachedSelectors.customerSelector;
                    // Remove elements when you come from payment to passengers
                    $wrapper.find('option[value!="-1"]').remove();
                    // Fill drop down values
                    this._fillPassengerSelector(data.userDTO.traveller, $wrapper);
                    if (!this.options.isBuyer) {
                        this.view._initPassengerList();
                    }
                } else if (data && data.userDTO) {
                    this.view.restoreFieldsLocalStorage();
                }
            },

            updatePassengerListSelected: function(data) {
                const defaultTraveller = this._getDefault(this.model.user.traveller);
                if (defaultTraveller && !defaultTraveller.id && !Odigeo._.isUndefined(Odigeo._.get(data, 'userDTO.id'))) {
                    this.showPassengerList(data);
                    this.model.passengerSelectedId = this._getDefault(this.model.user.traveller).id;
                    if (this.options.isBuyer) {
                        this.view.$cachedSelectors.contactDetailsSelector.val(this.model.passengerSelectedId);
                    } else {
                        this.view.setTravellerById(this.model.passengerSelectedId);
                    }
                }
            },

            initContactDetailsInfo: function(data) {
                var defaultPassenger = data ? this._getDefault(data.traveller) : '';
                this.trackingLoggedBuyer();
                this.model.user = data;
                this.model.passengerSelectedId = defaultPassenger ? defaultPassenger.id : -1;
                this.view._prefillEmail(data ? this.model.user.email : '');
                this.view.$cachedSelectors.fillBuyerCombo.addClass('hidden');
                this.view.$cachedSelectors.travellerTitleWarning.addClass('hidden');
                this.view.$cachedSelectors.passwordBox.addClass('hidden');

                // Prefill passenger values in contact details
                if (defaultPassenger && !this.view.isStepBack()) {
                    // Display the travellers that are Adults in the drop down
                    this.model.passengerType = 'ADULT';
                    // Fill the drop down
                    this.showPassengerList({userDTO: data, track: false});
                    this.view.$cachedSelectors.contactDetailsSelector.val(this.model.passengerSelectedId);
                    this.view._updateContactDetailsData(defaultPassenger);
                    this.view.$cachedSelectors.contactDetailsSelector.off().on(
                        Odigeo.Events.change,
                        Odigeo._.bind(function() {
                            this.view.onContactDetailsPassengerChanged();
                        }, this)
                    );
                } else if (!defaultPassenger) {
                    this.view.restoreFieldsLocalStorage();
                }
                if (data && !Odigeo._.isEmpty(this.model.user.email) && !Odigeo.AB.isNewNewsletterLogic) {
                    this.model.crmSubscribeCustomerEmail(this.model.user.email);
                }
                this.view.$cachedSelectors.passwordInput.val('');
                this.view._updateContactDetailsData(defaultPassenger);
                const addressRegex = new RegExp(/^[-/ ,.'A-Za-z0-9]+$/g);
                if (addressRegex.test(Odigeo._.get(defaultPassenger, 'profile.address.address'))) {
                    this.view._hideOrShowNonEditableContactDetailsLayer(defaultPassenger);
                }
            },

            crmSubscription: function(email) {
                if ( !Odigeo._.isEmpty(email)) {
                    this.model.crmSubscribeCustomerEmail(email);
                }
            },

            _getTravellerStructure: function() {
                var contactDetails = $.extend(true, {}, this.model.travellerModel);
                var traveller;
                if (this.model.passengerSelectedId !== -1) {
                    traveller = Odigeo._.find(this.model.user.traveller, {id: this.model.passengerSelectedId});
                    contactDetails.profile.address =
                        traveller.profile && traveller.profile.address ? traveller.profile.address : contactDetails.profile.address;
                    contactDetails.profile.prefixPhoneNumber = traveller.profile.prefixPhoneNumber;
                    contactDetails.profile.phoneNumber = traveller.profile.phoneNumber;
                    contactDetails.id = this.model.passengerSelectedId;
                } else if (
                    this.model.passengerSelectedId === -1 &&
                    ((!Odigeo._.isEmpty(this.model.user) && !Odigeo._.isUndefined(this._getDefault(this.model.user.traveller))) ||
                        Odigeo._.isEmpty(this.model.user))
                ) {
                    contactDetails.profile.name = this.view.$cachedSelectors.hideOnUserLogged.find('[name=name]').val();
                    contactDetails.profile.firstLastName = this.view.$cachedSelectors.hideOnUserLogged.find('[name=lastName]').val();
                    contactDetails.typeOfTraveller = 'ADULT';
                    contactDetails.profile.title = 'MR';
                    if (Odigeo._.isEmpty(this.model.user)) {
                        contactDetails.id = -1;
                    } else {
                        contactDetails.id = this._getDefault(this.model.user.traveller).id || -1;
                    }
                }
                return contactDetails;
            },

            _getPassengerData: function() {
                var traveller;
                var value;
                if (this.model.passengerSelectedId !== -1) {
                    traveller = Odigeo._.find(this.model.user.traveller, {id: Number(this.model.passengerSelectedId)});
                } else {
                    traveller = $.extend(true, {}, this.model.travellerModel);
                    traveller.typeOfTraveller = this.model.passengerType;
                    traveller.profile.address = null;
                }
                // This info will be saved in ProfileDTO
                Odigeo._.each(
                    this.view.$cachedSelectors.passengerInputs,
                    Odigeo._.bind(function(input) {
                        var $input = $(input);
                        value = this.passengerMap[$input.data('name')];

                        if (!Odigeo._.isUndefined(value)) {
                            if (value === 'gender' && $input.is(':checked')) {
                                traveller.profile.title = $input.val() === 'MALE' ? 'MR' : 'MS';
                            }
                            traveller.profile[value] = $input.val();
                        }
                    }, this)
                );
                return traveller;
            },

            _getContactDetailsData: function() {
                var contactDetails = this._getTravellerStructure();
                var phoneMap = Odigeo._.invert(this.contactDetailsMap.buyer);

                // Update traveller with the form values
                Odigeo._.each(
                    this.view.$cachedSelectors.passengerInputs,
                    Odigeo._.bind(function(input) {
                        var dataName = $(input).data('name');
                        var value = this.contactDetailsMap[dataName];
                        if (!Odigeo._.isEmpty(value)) {
                            contactDetails.profile.address[value] = $(input).val();
                        }
                        value = phoneMap[dataName];
                        if (!Odigeo._.isEmpty(value) && !Odigeo._.isUndefined(this.model.travellerModel.profile[value])) {
                            contactDetails.profile[value] = $(input).val();
                        }
                    }, this)
                );
                // Update first name with the value of lastname
                contactDetails.profile.firstLastName = this.view.$cachedSelectors.editableBuyerLayer.find('[data-name=lastName]').val();
                return contactDetails;
            },

            getTravellersData: function(response) {
                var passengerData = this._getPassengerData();
                if (this.view.saveName) {
                    Odigeo.trigger(
                        this.name + ':' + response,
                        {
                            saveAfterUpdate: false,
                            traveller: passengerData,
                        },
                        'passenger'
                    );
                }
            },

            getContactDetails: function(response) {
                Odigeo.trigger(this.name + ':' + response, this._getContactDetailsData(), 'contactDetails');
            },

            updateBaggageQuantity: function(currentBaggage) {
                var storedBaggage = this.model.get('selectedBaggageQuantity');
                this.model.set({selectedBaggageQuantity: storedBaggage > 0 ? storedBaggage - currentBaggage : 0});
            },

            getPassengerFullName: function() {
                var info = this._getPassengerData();
                return {
                    name: info.profile.name,
                    firstLastName: info.profile.firstLastName,
                    id: this.id,
                };
            },

            // MODELVIEW
            execute: function(func) {
                var args = [].slice.call(arguments, 1);

                switch (func) {
                    case 'validate':
                        this.validate.apply(this, args);
                        break;
                    case 'validateBuyerWithPaxErrors':
                        this.validateBuyerWithPaxErrors.apply(this, args);
                        break;
                    case 'getBuyerDTO':
                        this.view.getBuyerDTO.apply(this.view, args);
                        break;
                    case 'selectPassenger':
                        this.view.selectPassenger.apply(this.view, args);
                        break;
                    case 'collapse':
                        this.view.collapse.apply(this.view, args);
                        break;
                    case 'expand':
                        this.view.expandPassenger.apply(this.view, args);
                        break;
                    case 'userLoggedShowPassengerList':
                        this.showPassengerList.apply(this, args);
                        break;
                    case 'updatePassengerListSelected':
                        this.updatePassengerListSelected.apply(this, args);
                        break;
                    case 'crmSubscription':
                        this.crmSubscription.apply(this, args);
                        break;
                    case 'userNotLoggedHidePassengerList':
                        this.view.hidePassengerList.apply(this.view, args);
                        break;
                    case 'hideTraveller':
                        this.view.onHideTraveller.apply(this.view, args);
                        break;
                    case 'showTraveller':
                        this.view.onShowTraveller.apply(this.view, args);
                        break;
                    case 'storeLocalData':
                        this.view.storeLocalData.apply(this.view, args);
                        break;
                    case 'userNotLoggedHideNonEditableBuyerLayer':
                        this.view.onUserNotLogged.apply(this.view, args);
                        break;
                    case 'userLoggedSetBuyerData':
                        this.initContactDetailsInfo.apply(this, args);
                        break;
                    case 'checkBaggages':
                        this.view.checkBaggages.apply(this.view, args);
                        break;
                    case 'updatePassengerIdentificationType':
                        this.view.updatePassengerIdentificationType.apply(this.view, args);
                        break;
                    case 'updatePassengerSelected':
                        this.view.updatePassengerSelected();
                        break;
                    case 'getTravellersData':
                        this.getTravellersData.apply(this, args);
                        break;
                    case 'getContactDetails':
                        this.getContactDetails.apply(this, args);
                        break;
                    case 'updateBaggageQuantity':
                        this.updateBaggageQuantity.apply(this, args);
                        break;
                    case 'showEmail':
                        this.view.showEmail.apply(this.view, args);
                        break;
                    case 'showForcePrimeLoginIndicator':
                        this.view.showForcePrimeLoginIndicator.apply(this.view, args);
                        break;
                    case 'closeForceLoginPopup':
                        this.view.closeForceLoginPopup(this.view, args);
                        break;
                    case 'defaultNifSelection':
                        this.view.defaultNifSelection.apply(this.view, args);
                        break;
                    case 'getFrequentFlyerTrackingData':
                        this.view.frequentFlyerCodesTrackingData.apply(this.view, args);
                        break;
                    case 'getFrequentFlyerTrackingOnInit':
                        this.view.frequentFlyerCodesTrackingDataOnInit.apply(this.view, args);
                        break;
                    case 'getFrequentFlyerMealsTracking':
                        this.view.frequentFlyerMealsTracking.apply(this.view, args);
                        break;
                    case 'getPassengerFullName':
                        this.getPassengerFullName.apply(this, args);
                        break;
                    case 'setTravellerById':
                        this.view.setTravellerById.apply(this.view, args);
                        break;
                }
                return this;
            },
        })
    )
);
